'use client';

import { c as _c } from "react/compiler-runtime";
import { KeyRound, Layers } from 'lucide-react';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { Container, Section, SectionHeader, Card, MotionBlock, PrimaryButton } from './shared';
import { cn } from '@/lib/utils';
const icons = [KeyRound, Layers] as const;
export function DeploymentSection() {
  const $ = _c(19);
  const d = useCadrinoCopy().deployment;
  let t0;
  if ($[0] !== d.subtitle || $[1] !== d.title) {
    t0 = <MotionBlock><SectionHeader title={d.title} subtitle={d.subtitle} /></MotionBlock>;
    $[0] = d.subtitle;
    $[1] = d.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== d.paths) {
    t1 = d.paths.map(_temp2);
    $[3] = d.paths;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="mt-12 grid gap-6 lg:grid-cols-2">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("rounded-xl border border-white/[0.08] bg-cadrino-bg/50 px-4 py-3", "text-center text-sm text-slate-400");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== d.note) {
    t4 = <p className={t3}>{d.note}</p>;
    $[8] = d.note;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== d.cta) {
    t5 = <div className="mt-6 flex justify-center"><PrimaryButton href="#contact">{d.cta}</PrimaryButton></div>;
    $[10] = d.cta;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <MotionBlock className="mt-8">{t4}{t5}</MotionBlock>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t0 || $[16] !== t2 || $[17] !== t6) {
    t7 = <Section id="how-we-work" className="border-t border-white/[0.08] bg-cadrino-surface/15"><Container>{t0}{t2}{t6}</Container></Section>;
    $[15] = t0;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp2(path, i) {
  const Icon = icons[i] ?? KeyRound;
  return <MotionBlock key={path.title} delay={i * 0.05}><Card className="flex h-full flex-col"><div className="flex items-start gap-3"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-cadrino-primary/15 text-cadrino-primary"><Icon className="h-5 w-5" aria-hidden={true} /></div><div><p className="text-xs font-medium uppercase tracking-wider text-cadrino-accent">{path.badge}</p><h3 className="mt-1 text-lg font-semibold text-slate-100">{path.title}</h3></div></div><p className="mt-4 text-sm leading-relaxed text-cadrino-muted">{path.description}</p><ul className="mt-4 flex-1 space-y-2">{path.bullets.map(_temp)}</ul></Card></MotionBlock>;
}
function _temp(bullet) {
  return <li key={bullet} className="flex gap-2 text-sm leading-relaxed text-slate-300"><span className="shrink-0 text-cadrino-accent" aria-hidden={true}>→</span><span>{bullet}</span></li>;
}